import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import arrow1 from "../../assets/images/icon/arrow-1.svg";
// import graph from "../../assets/images/icon/graph.png";
import FunnelSeries from "./FunnelSeries";
import PieChartDetails from "./PieChart";
import ReactApexChart from "react-apexcharts";
import AcceptanceChart from "./AcceptanceChart";
import { FetchDashboardData } from "helpers/backend_helper";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

const NewApplicantChart = props => {
  const {t} = useTranslation();
  let datafromDashboard = props?.data || {};
  const [data, setData] = useState(datafromDashboard);

  let acceptanceDetails = props?.acceptanceDetails || {};
  let type = props?.type || "";
  let startDate = props?.startDate || "";
  let endDate = props?.endDate || "";
  let jobTitles = props?.jobTitles || [];

  // useEffect(() => {
  //   setData(datafromDashboard);
  //   // console.log("datafrom dashborad", datafromDashboard);
  // }, [datafromDashboard]);

  let myData = [
    {
      stage: "Total Applied",
      applicants: data?.totalApplicants || 0,
      percentage: 100,
    },
    // {
    //     stage: "Pending",
    //     applicants: data?.pendingUsers || 0
    // },
    {
      stage: "Link Sent",
      applicants: data?.screeningUsers || 0,
      percentage:
        ((data?.screeningUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    {
      stage: "Called for Interview",
      applicants: data?.scheduledUsers || 0,
      percentage:
        ((data?.scheduledUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    {
      stage: "Selected",
      applicants: data?.selectedUsers || 0,
      percentage:
        ((data?.selectedUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    {
      stage: "Onboarded",
      applicants: data?.onboardedUsers || 0,
      percentage:
        ((data?.onboardedUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    // {
    //     stage: "On Hold",
    //     applicants: data?.onholdUsers || 0
    // },
    // {
    //     stage: "Rejected",
    //     applicants: data?.rejectedUsers || 0
    // },
  ];

  const [selectedJobTitle, setSelectedJobTitle] = useState("");

  const handleJobTitleChange = e => {
    const jobId = e.target.value;
    setSelectedJobTitle(jobId);
    getDashboardData(jobId);
  };

  const getDashboardData = async jobId => {
    const payload = `?type=${type}&startDate=${startDate}&endDate${endDate}=&jobId=${jobId}`;
    await FetchDashboardData(payload)
      .then(res => {
        let responseData = decryptDataFromArray(res);

        if (responseData?.status) {
          let dataFromApi = responseData?.data?.funnelData;
          setData(dataFromApi);
        }
      })
      .catch(err => {
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <div className="HiringAcceptanceChart">
      <div className="eligible-content mt-1">
        <h3 className="d-flex align-items-center gap-2 mb-0">
          {t(`Dashboard.Acceptance Rate`)}
        </h3> 
      </div>
      <div className="acceptance-rate">
        <div className="graph-chart">
          <h4>{t(`Dashboard.onboard_acceptance_rate`)}</h4>
          <div className="accepatance-section">
            <div className="offered-card">
              <p>{t(`Dashboard.new_candidates %`)}</p>
              <ul>
                <li>
                  {acceptanceDetails?.new_applicant || 0} <span>{t(`Dashboard.NewApplication`)}</span>
                </li>
                <li>
                  {acceptanceDetails?.onboarded || 0} <span>{t(`Dashboard.Onboarded`)}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="acceptance-graph position-relative">
          <AcceptanceChart data={acceptanceDetails} />
        </div>
      </div>
    </div>
  );
};

export default NewApplicantChart;
